
        Component.define('products', (el, params) => {
            const $el = $(el);

        });